import React from 'react';
import { formatOptionsNote, normalizeNote } from '../../../utils/menuOptions';
import './OrderLineOptions.css';

interface OrderLineOptionsProps {
  /** Persisted variant + add-on note ("Medium | + Extra cheese"). */
  optionsNote?: string | null;
  itemNote?: string | null;
  className?: string;
}

/** Variant / add-ons and the cooking request under an order line. Rendered as text only. */
const OrderLineOptions: React.FC<OrderLineOptionsProps> = ({ optionsNote, itemNote, className }) => {
  const options = formatOptionsNote(optionsNote);
  const note = normalizeNote(itemNote);
  if (!options && !note) return null;
  return (
    <span className={`order-line-options${className ? ` ${className}` : ''}`}>
      {options && <span className="order-line-options__summary">{options}</span>}
      {note && <span className="order-line-options__note">“{note}”</span>}
    </span>
  );
};

/** Order-level note for the kitchen. */
export const OrderKitchenNote: React.FC<{ note?: string | null; className?: string }> = ({ note, className }) => {
  const text = normalizeNote(note);
  if (!text) return null;
  return (
    <div className={`order-kitchen-note${className ? ` ${className}` : ''}`} role="note">
      <span className="order-kitchen-note__icon" aria-hidden="true">
        <i className="fa fa-sticky-note-o" />
      </span>
      <div className="order-kitchen-note__body">
        <span className="order-kitchen-note__label">Note for the kitchen</span>
        <p className="order-kitchen-note__text">{text}</p>
      </div>
    </div>
  );
};

export default OrderLineOptions;
